export enum StepVariant {
  complete = 'complete',
  in_progress = 'in_progress',
  future = 'future',
}
